import React from 'react';

import { PendingTranscriptionLoader } from '@eluve/frontend-feature-appointment';

import { AppointmentInSessionTranscript } from '../../../components/AppointmentInSessionTranscript';
import { UploadingFileLoader } from '../../../components/UploadingFileLoader';
import { useTranscriptionMachineSelector } from '../hooks/useTranscriptionMachine';

export const TranscriptionWidgetTranscript: React.FC = () => {
  const tenantId = useTranscriptionMachineSelector((s) => s.context.tenantId);

  const appointmentId = useTranscriptionMachineSelector(
    (s) => s.context.sessionAppointmentId,
  );
  const currentAppointmentInSession = useTranscriptionMachineSelector((s) =>
    s.matches({ InSession: 'Recording' }),
  );

  if (!appointmentId) {
    return null;
  }

  return (
    <>
      {!currentAppointmentInSession && (
        <>
          <PendingTranscriptionLoader
            tenantId={tenantId}
            appointmentId={appointmentId}
          />
          <UploadingFileLoader appointmentId={appointmentId} />
        </>
      )}
      <AppointmentInSessionTranscript
        className="p-4"
        compact
        inSession={currentAppointmentInSession}
      />
    </>
  );
};
